/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrowserAnalytics = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v7h-2V8H4v12h3v2H2zm2 2v2h16V4zm5 7h14v12H9zm2 2v8h10v-8zm6 2v5h-2v-5zm3 2.5V20h-2v-2.5zM12 20v-4h2v4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBrowserAnalytics as BrowserAnalytics };
